import { giphyGreen } from '@giphy/js-brand'
import React from 'react'
import styled, { keyframes } from 'styled-components'

const slideRight = keyframes`
    0% { transform: translate3d(-100%, 0, 0); }
    100% { transform: translate3d(400%, 0, 0); }
`

const Container = styled.div`
    height: 4px;
    overflow: hidden;
    position: relative;
    width: 100%;
`

const Snake = styled.div`
    animation: ${slideRight} 2s cubic-bezier(0.83, 0, 0.17, 1) 0.15s infinite backwards;
    background: ${giphyGreen};
    border-radius: 2px;
    height: 100%;
    left: 0;
    opacity: 0.25;
    position: absolute;
    top: 0;
    width: 30%;

    &:nth-child(2) {
        animation-delay: 0.1s;
        opacity: 0.5;
    }

    &:nth-child(3) {
        animation-delay: 0.05s;
        opacity: 0.75;
    }

    &:nth-child(4) {
        animation-delay: 0s;
        opacity: 1;
    }
`

type Props = {
    className?: string
}

const CreationToolsSnakeLoader = ({ className }: Props) => (
    <Container className={className}>
        <Snake />
        <Snake />
        <Snake />
        <Snake />
    </Container>
)

export default CreationToolsSnakeLoader
